import { Controller } from "@hotwired/stimulus"

// A handful of links (game cards on the main list, "Other games" on a show
// page) carry data-turbo-frame="_top" to escape the surrounding games_list
// frame for a real top-level page visit -- but landing on the new page
// doesn't reliably reset scroll position on its own. Scroll explicitly on
// click rather than a global turbo:visit listener: Turbo.visit(url, {frame})
// dispatches turbo:visit too (confirmed in Turbo's own source, session.visit
// doesn't care about the frame option), so a document-level listener would
// also catch every frame-scoped pagination/search/filter visit elsewhere in
// this app and break "don't scroll while filtering." Scoping this to the
// specific _top links avoids that entirely.
export default class extends Controller {
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "auto" })
  }
}
